module.exports = __webpack_public_path__ + "img/threads.fb285d7d.png";